
import { Component, Vue } from "vue-property-decorator";
import { ConfirmPopupOptions } from "@/core/CommonDefinition";

@Component
export default class ConfirmPopup extends Vue {
  icon: string = "";
  message: string = "";

  dialog: boolean = false;
  resolve: any = null;
  reject: any = null;
  options: ConfirmPopupOptions = {
    color: "error",
    width: "30vw"
  };

  open(message, options?) {
    this.dialog = true;
    this.message = message;
    this.options = Object.assign(this.options, options);
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  agree() {
    this.resolve(true);
    this.dialog = false;
  }

  cancel() {
    this.resolve(false);
    this.dialog = false;
  }
}
